import React, { useEffect, useRef, useState } from 'react';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { AlertCircle, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { BASE_URL, SITE_URL } from '@/config/api';
import { useToast } from '@/hooks/use-toast';
import { useLanguage } from '@/contexts/LanguageContext';

const GoogleGlyph = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">
    <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
    <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
    <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
    <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
  </svg>
);

interface GoogleWebviewAuthProps {
  onClose: () => void;
}

const GOOGLE_CLIENT_ID = '113709107751-i3nl17s0clr60ntunl4b9f9l3i60u7fg.apps.googleusercontent.com';
const REDIRECT_URI = `${SITE_URL}/oauth2redirect/google.html`;

const GoogleWebviewAuth: React.FC<GoogleWebviewAuthProps> = ({ onClose }) => {
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [showAuthButton, setShowAuthButton] = useState(true);
  const authWindowRef = useRef<Window | null>(null);
  const intervalRef = useRef<number | null>(null);
  const { toast } = useToast();
  const { t } = useLanguage();


  /*const cleanup = () => {
    if (intervalRef.current) {
      window.clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };*/

  useEffect(() => {
    const channel = new BroadcastChannel('auth');
    channel.onmessage = () => {
      console.log('pwaa test');
      // Token already processed by google.html, just close window here
      window.close();
    };

    return () => {
      channel.close();
     // cleanup();
    };
  }, []);

  const handleGoogleAuthClick = () => {

    /*toast({
      title: "Available Soon",
      description: "Google Sign-In in App is not yet available. Please use another login method.",
    });*/

    setLoading(true);
    setShowAuthButton(false);

    const authUrl = `https://accounts.google.com/o/oauth2/v2/auth` +
      `?client_id=${GOOGLE_CLIENT_ID}` +
      `&redirect_uri=${encodeURIComponent(REDIRECT_URI)}` +
      `&response_type=code` +
      `&scope=openid email profile` +
      `&prompt=select_account`;

    const popup = window.open(authUrl, '_blank');
    if (!popup) {
      //setError("Impossible d'ouvrir la fenêtre. Autorisez les pop-ups.");
      setLoading(false);
      setShowAuthButton(true);
      return;
    }
    
    /*authWindowRef.current = popup;

    intervalRef.current = window.setInterval(() => {
      if (popup.closed) {
        cleanup();
        setLoading(false);
        setShowAuthButton(true);
        setError("Fenêtre fermée avant la fin de l'authentification.");
      }
    }, 1000);*/
  };
  

  if (error) {
    return (
      <Alert variant="destructive">
        <AlertCircle className="h-4 w-4" />
        <AlertDescription>{error}</AlertDescription>
      </Alert>
    );
  }

  if (loading) {
    return (
      <div className="flex items-center justify-center p-4">
        <Loader2 className="h-6 w-6 animate-spin mr-2" />
        <span>Connexion en cours…</span>
      </div>
    );
  }

  return showAuthButton ? (
    <div className="w-full sm:w-auto flex justify-center items-center">
      <Button
        type="button"
        variant="outline"
        onClick={handleGoogleAuthClick}
        className="w-full h-12 rounded-full bg-background flex items-center justify-center gap-3 text-base font-medium"
      >
        <GoogleGlyph />
        <span>{t('login.continueWithGoogle') || 'Continue with Google'}</span>
      </Button>
    </div>
  ) : null;
};

export default GoogleWebviewAuth;
